var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.brandUrl)?_c('div',{staticClass:"col-12 text-center"},[_c('p',{staticClass:"mt-5 small"},[_vm._v(_vm._s(_vm.$t('redirect-in-seconds'))+".")]),_c('a',{staticClass:"btn btn-light mt-1",attrs:{"href":_vm.brandUrl}},[_vm._v(_vm._s(_vm.$t('redirect')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }